import React, { useState, useEffect } from 'react';
import './Nav.css';

const Nav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-logo">
        <img
          src="https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=100&q=80"
          alt="面道Logo"
          className="nav-logo-img"
        />
        <span className="logo-char">面道</span>
      </div>
      <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
        <li><a href="#home" onClick={(e) => scrollToSection(e, '#home')}>首页</a></li>
        <li><a href="#menu" onClick={(e) => scrollToSection(e, '#menu')}>招牌面食</a></li>
        <li><a href="#gallery" onClick={(e) => scrollToSection(e, '#gallery')}>匠心工艺</a></li>
        <li><a href="#about" onClick={(e) => scrollToSection(e, '#about')}>品牌故事</a></li>
        <li><a href="#contact" onClick={(e) => scrollToSection(e, '#contact')}>联系我们</a></li>
      </ul>
      <div className="nav-cta">
        <a href="#menu" className="btn-reserve" onClick={(e) => scrollToSection(e, '#menu')}>预订座位</a>
      </div>
      <button
        className={`nav-toggle ${isMobileMenuOpen ? 'active' : ''}`}
        aria-label="菜单"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
};

export default Nav;
